import './WLAD.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class WLAD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
